import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import { ApplicationState, persistor } from '../..';
import api from '../../../service/api';
import { requestHeaders } from '../../../service/apiHelper';
import { SKW_AUTH, SKW_PREFIX } from '../../../utils/constants';
import { cleanStateEstoque } from '../estoque/actions';
import { clearCart } from '../estoqueCart/actions';
import { cleanStateMoviEntrada } from '../movimentacoes/actions';
import { cleanStateMoviSaida } from '../solicitacoesRetorno/actions';
import { cleanSelect } from '../transportadoras/actions';

import {
  loginSuccess,
  loginFailure,
  loginRequest,
  passwordRequest,
  passwordSuccess,
  passwordFailure,
  cleanState,
  updateSuccess,
  updateFailure,
  updateRequest,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  resetPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  profileUpdateRequest,
  profileUpdateSuccess,
} from './actions';
import { storagePersist } from 'utils/storagePersist';

export function* login({ payload }: ReturnType<typeof loginRequest>): any {
  try {
    localStorage.removeItem('keypath');
    const response = yield call(api.post, `call?serviceName=${SKW_PREFIX}login`, payload.auth);
    yield put(
      loginSuccess(response.data.token, {
        nome: response.data.nome,
        inscricoesEstaduais: response.data.inscricoesEstaduais,
        email: response.data.email,
        perfil: response.data.perfil,
        master: response.data.master,
        masterEditar: response.data.masterEditar,
        masterIncluir: response.data.masterIncluir,
        depositantes: response.data.depositantes,
        centroDistribuicao: response.data.centrosDistribuicao,
        isPossibleNewEmptyColect: response.data.isPossibleNewEmptyColect,
      })
    );
    if (!response.data.token)
      Swal.fire({ title: 'Usuário ou senha inválido!', html: '', icon: 'warning' });
  } catch (error: any) {
    yield put(loginFailure('Usuário ou senha inválido!'));

    if (error.response) {
      // A requisição foi feita e o servidor respondeu com um código de status
      // que sai do alcance de 2xx
      return Swal.fire({
        title: error?.response?.data?.mensagem ?? error?.response?.data?.Erro,
        html: '',
        icon: 'warning',
        showConfirmButton: true,
      });
    } else {
      // Alguma coisa acontenceu ao configurar a requisição que acionou este erro.
      Swal.fire({
        title: 'Não foi possível fazer login, contate o suporte',
        html: '',
        icon: 'warning',
        showConfirmButton: true,
      });
    }
  }
}

export function* logout({ payload }: ReturnType<typeof logoutRequest>): any {
  try {
    const state = yield select();
    yield call(api.post, `call?serviceName=${SKW_PREFIX}logout&token=${state.auth.token}`, {});

    storagePersist();
    localStorage.removeItem('persist:root');

    persistor.purge();
    persistor.purge();
    storagePersist();
    localStorage.removeItem('persist:root');
    yield put(cleanState());
    yield put(cleanStateEstoque());
    yield put(cleanStateMoviEntrada());
    yield put(cleanStateMoviSaida());
    yield put(cleanSelect());
    yield put(clearCart());
    yield put(logoutSuccess());
  } catch (err) {
    yield put(logoutFailure('Usuário ainda está Logado!'));
  }
}

export function* forgotPassword({ payload }: ReturnType<typeof passwordRequest>): any {
  try {
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}recuperarSenha&accessKey=${SKW_AUTH}`,
      {
        email: payload.username,
      }
    );

    yield put(passwordSuccess(response.data.sucesso));
  } catch (err: any) {
    yield put(passwordFailure(err.response.data.sucesso));
  }
}

export function* resetPassword({ payload }: ReturnType<typeof resetPasswordRequest>): any {
  try {
    yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}alterarSenha&accessKey=${SKW_AUTH}&token=${payload.token}`,
      { senha: payload.password }
    );

    yield put(resetPasswordSuccess());
  } catch (err: any) {
    yield put(resetPasswordFailure(err.response.data.sucesso));
  }
}

export function* updateToken({ payload }: ReturnType<typeof updateRequest>): any {
  try {
    const state: ApplicationState = yield select();
    const headers = requestHeaders(state.auth.token);
    const response = yield call(
      api.post,
      `/call?serviceName=${SKW_PREFIX}login&accessKey=b82b31b4-6ad0-4d16-8351-d8640f263acd`,
      payload.partnerAuth,
      {
        headers: headers,
      }
    );
    yield put(updateSuccess(response.data.login['access_token']));
  } catch (err: any) {
    yield put(cleanState());
    yield put(updateFailure(err.response.data.message));
  }
}

export function* updateProfile({ payload }: ReturnType<typeof profileUpdateRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `/call?serviceName=${SKW_PREFIX}alterarUsuario&accessKey=${SKW_AUTH}&token=${state.auth.token}`,
      payload.profile
    );

    yield put(
      profileUpdateSuccess({
        nome: response.data.nome,
        inscricoesEstaduais: response.data.inscricoesEstaduais,
        email: response.data.email,
        perfil: response.data.perfil,
        depositantes: response.data.depositantes,
        centroDistribuicao: response.data.centrosDistribuicao,
        master: response.data.master,
      })
    );
    Swal.fire({
      title: 'Dados Cadastrais atualizados com sucesso!',
      showConfirmButton: false,
      timer: 1500,
      html: '',
      icon: 'success',
    });
  } catch (err) {
    Swal.fire({
      title: 'Senha inválida!',
      html: '',
      showConfirmButton: false,
      timer: 1500,
      icon: 'warning',
    });
  }
}
